module.exports = __webpack_public_path__ + "static/media/resume_icon.57a42c48.svg";